module.exports = __webpack_public_path__ + "static/media/heatmap@2x.13308984.png";